import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable()
export class AuthTokenGuard implements CanActivate {
    public token: any;
    constructor(private router: Router, private authService: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
        this.token = route.queryParams.token;
        return new Promise((resolve, reject) => {
            this.authService.validateToken(this.token)
                .then((data: any) => {
                    if (data.msg == 'Valid token.') {
                        route.data = { object: data.object };
                        window.scroll(0, 0);
                        resolve(true);
                    } else {
                        this.router.navigate(['token-error'], { state: { token: route.queryParams.token } });
                        reject(false);
                    }
                })
                .catch((error) => {
                    this.router.navigate(['token-error'], { state: { token: route.queryParams.token } });
                    reject(false);
                });
        });
    }
}
